import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
} from '@angular/router';
import { Observable } from 'rxjs';
import { TokenStorageService } from '../services/helpers/token.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanLoad {
  constructor(
    private router: Router,
    private tokenStorage: TokenStorageService,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    return this.checkAndRedirect(state.url);
  }
  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> {
    const url = location.href;
    const redirectUrl = location.pathname;
    return this.checkAndRedirect(url, redirectUrl);
  }
  private checkAndRedirect(url, redirectUrl = null): any {
    this.parseUrlAndSave(url);

    if (!sessionStorage.getItem('authorization')) {
      return this.router.navigate(['auth/login']);
    } else {
      return true;
    }
  }

  parseUrlAndSave(url: string): void {
    const parsedUrl = new URL(url, window.location.origin);
    const token = parsedUrl.searchParams.get('token');
    const authorization = parsedUrl.searchParams.get('authorization');
    const account = parsedUrl.searchParams.get('account');
    const company = parsedUrl.searchParams.get('comp');
    const colorScheme = parsedUrl.searchParams.get('color_scheme');
    const id = parsedUrl.searchParams.get('id');
    if (token) {
      const parsedToken = JSON.parse(token);
      this.tokenStorage.saveToken(parsedToken.access_token);
      this.tokenStorage.saveRefreshToken(parsedToken.refresh_token);
      this.tokenStorage.saveUser(parsedToken);
      this.tokenStorage.saveExpireRefreshToken(
        parsedToken.refresh_expire.toString(),
      );
      this.tokenStorage.saveExpireToken(parsedToken.access_expire.toString());
    }
    if (authorization) {
      sessionStorage.setItem('authorization', 'true');
    }
    if (account) {
      sessionStorage.setItem('account', account);
    }
    if (company) {
      sessionStorage.setItem('currentCompany', company);
      try {
        const parsedCompany = JSON.parse(company);
        if (parsedCompany?.color_scheme) {
          sessionStorage.setItem('color_scheme', parsedCompany.color_scheme);
        }
      } catch {
        // Keep guard resilient to malformed query params.
      }
    }
    if (colorScheme) {
      sessionStorage.setItem('color_scheme', colorScheme);
    }
    if (id) {
      sessionStorage.setItem('currentSession', id);
    }
  }
}
